import { bl_sfa_project_qualification_criteria_set_link_RowClass } from "../../../dbschema/bl_sfa_project_qualification_criteria_set_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaProjectQualificationCriteriaSetLinkContainerModel extends BaseContainerModel {
    bl_sfa_project_qualification_criteria_set_link: bl_sfa_project_qualification_criteria_set_link_RowClass = new bl_sfa_project_qualification_criteria_set_link_RowClass();
}
